/* import __COLOCATED_TEMPLATE__ from './walkthrough-popover.hbs.js'; */
import SetupGuideLeaveModal from '@dashboard/shared-ui/components/setup-guide/leave-modal';
import { inject as service } from '@ember/service';
import Component from '@ember/component';

/**
## Setup Guide/Walkthrough Popover

A popover component for the Setup Guide's walkthroughs

### Example Usage

```handlebars
{{setup-guide/walkthrough-popover popoverClassNames="popover--fly-down popover--align-right pointer--top pointer--align-right"
                                  step=currentStep
                                  isActive=walkthrough.isActive}}
```

### Parameters
@param {string} popoverClassNames  - class names for the component
@param {Object} step - the WalkthroughStep the popover is showing
@param {boolean} isActive - if the popover is active

Sass dependencies at: `@square/glass-ui/addon/styles/@square/dialog/walkthrough/_walkthrough.scss`
*/

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  modal: service(),
  step: null,
  isActive: null,
  actions: {
    close() {
      return this.modal.open(SetupGuideLeaveModal);
    }
  }
});